"use strict";

$(document).ready(function () {
  $(".calendar-dropdown").click(function (event) {
    $(this).toggleClass("active");
  });
  var outlookBtn = document.querySelector('#calendar-outlook');
  if (outlookBtn) {
    var $outlookBtn = $(outlookBtn);
    var eventid = $outlookBtn.data("eventid");
    outlookBtn.addEventListener("click", function (e) {
      e.preventDefault();
      fetch('/api/sitecore/events/OutlookCalendar?ContextItemId=' + eventid).then(function (resp) {
        return resp.blob();
      }).then(function (blob) {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'event.ics';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
    });
  }
  ;
  var appleBtn = document.querySelector('#calendar-apple');
  if (appleBtn) {
    var $appleBtn = $(appleBtn);
    var eventid = $appleBtn.data("eventid");
    appleBtn.addEventListener("click", function (e) {
      e.preventDefault();
      fetch('/api/sitecore/events/AppleCalendar?ContextItemId=' + eventid).then(function (resp) {
        return resp.blob();
      }).then(function (blob) {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'event.ics';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
    });
  }
  ;
});